import React, { FunctionComponent } from 'react';
import { NavLink } from 'react-router-dom';
import {
	Square,
	StyledSideMenuItem,
	StyledSideMenuItemTag,
	StyledActiveBar,
} from './SideMenuItem.styles';
import { useMenuContext } from '../menuContext';
import { MenuItemProps } from '../menuTypes';

const SideMenuItem: FunctionComponent<MenuItemProps> = ({
	text,
	icon,
	link,
	h = '40px',
	bg = 'transparent',
	color = 'textSubtle',
	className,
	tabIndex,
}) => {
	const { isActive } = useMenuContext();

	return (
		<StyledSideMenuItem
			$backgroundColor={bg}
			$boxSize={h}
			$color={color}
			$isActive={isActive}
			className={className}
			tabIndex={tabIndex}
		>
			<StyledActiveBar className="active-bar" $isActive={isActive} />
			<Square className="square" $boxSize={h}>
				{icon}
			</Square>
			<StyledSideMenuItemTag
				bg="bgCard"
				borderRadius="4px"
				px="md"
				py="md"
			>
				<NavLink to={link}>{text}</NavLink>
			</StyledSideMenuItemTag>
		</StyledSideMenuItem>
	);
};

export default SideMenuItem;
